<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part-title"><a id="page_6">Act I</a></h2><a id="page_6">
<h3 class="ch-titlea" id="lev1"><span class="bold">Scene I. London. A Street</span></h3>
<p class="poem2"><em class="italic">[Enter GLOSTER.]</em></p>
<p class="poem">GLOSTER: Now is the winter of our discontent</p>
<p class="poem">Made glorious summer by this sun of York;</p>
<p class="poem">And all the clouds that lour’d upon our house</p>
<p class="poem">In the deep bosom of the ocean buried.</p>
<p class="poem">Now are our brows bound with victorious wreaths;</p>
<p class="poem">Our bruisèd arms hung up for monuments;</p>
<p class="poem">Our stern alarums chang’d to merry meetings,</p>
<p class="poem">Our dreadful marches to delightful measures.</p>
<p class="poem">Grim-visag’d war hath smooth’d his wrinkled front;</p>
<p class="poem">And now,—instead of mounting barbèd steeds</p>
<p class="poem">To fright the souls of fearful adversaries,—</p>
<p class="poem">He capers nimbly in a lady’s chamber</p>
<p class="poem">To the lascivious pleasing of a lute.</p>
<p class="poem">But I,—that am not shap’d for sportive tricks,</p>
<p class="poem">Nor made to court an amorous looking-glass;</p>
<p class="poem">I, that am rudely stamp’d, and want love’s majesty</p>
<p class="poem">To strut before a wanton ambling nymph;</p>
<p class="poem">I, that am curtail’d of this fair proportion,</p>
<p class="poem">Cheated of feature by dissembling nature,</p>
<p class="poem">Deform’d, unfinish’d, sent before my time</p>
<p class="poem">Into this breathing world scarce half made up,</p>
<p class="poem">And that so lamely and unfashionable</p>
</a><p class="poem"><a id="page_6"></a><a id="page_7">That dogs bark at me as I halt by them;—</a></p><a id="page_7">
<p class="poem">Why, I, in this weak piping time of peace,</p>
<p class="poem">Have no delight to pass away the time,</p>
<p class="poem">Unless to spy my shadow in the sun,</p>
<p class="poem">And descant on mine own deformity:</p>
<p class="poem">And therefore,—since I cannot prove a lover,</p>
<p class="poem">To entertain these fair well-spoken days,—</p>
<p class="poem">I am determinèd to prove a villain,</p>
<p class="poem">And hate the idle pleasures of these days.</p>
<p class="poem">Plots have I laid, inductions dangerous,</p>
<p class="poem">By drunken prophecies, libels, and dreams,</p>
<p class="poem">To set my brother Clarence and the king</p>
<p class="poem">In deadly hate the one against the other:</p>
<p class="poem">And if King Edward be as true and just</p>
<p class="poem">As I am subtle, false, and treacherous,</p>
<p class="poem">This day should Clarence closely be mew’d up,—</p>
<p class="poem">About a prophecy which says that G</p>
<p class="poem">Of Edward’s heirs the murderer shall be.</p>
<p class="poem">Dive, thoughts, down to my soul:—here Clarence comes.</p>
<p class="poem1"><em class="italic">[Enter CLARENCE, guarded, and BRAKENBURY.]</em></p>
<p class="poem1">Brother, good day: what means this armèd guard</p>
<p class="poem">That waits upon your grace?</p>
<p class="poem1">CLARENCE: His majesty,</p>
<p class="poem">Tendering my person’s safety, hath appointed</p>
<p class="poem">This conduct to convey me to the Tower.</p>
<p class="poem1">GLOSTER: Upon what cause?</p>
<p class="poem1">CLARENCE: Because my name is George.</p>
</a><p class="poem1"><a id="page_7"></a><a id="page_8">GLOSTER: Alack, my lord, that fault is none of yours;</a></p><a id="page_8">
<p class="poem">He should, for that, commit your godfathers:—</p>
<p class="poem">O, belike his majesty hath some intent</p>
<p class="poem">That you should be new-christen’d in the Tower.</p>
<p class="poem">But what’s the matter, Clarence? may I know?</p>
<p class="poem1">CLARENCE: Yea, Richard, when I know; for I protest</p>
<p class="poem">As yet I do not: but, as I can learn,</p>
<p class="poem">He hearkens after prophecies and dreams;</p>
<p class="poem">And from the cross-row plucks the letter G,</p>
<p class="poem">And says a wizard told him that by G</p>
<p class="poem">His issue disinherited should be;</p>
<p class="poem">And, for my name of George begins with G,</p>
<p class="poem">It follows in his thought that I am he.</p>
<p class="poem">These, as I learn, and such like toys as these,</p>
<p class="poem">Hath mov’d his highness to commit me now.</p>
<p class="poem1">GLOSTER: Why, this it is when men are rul’d by women:—</p>
<p class="poem"> ‘Tis not the king that sends you to the Tower;</p>
<p class="poem">My Lady Grey his wife, Clarence, ‘Tis she</p>
<p class="poem">That tempers him to this extremity.</p>
<p class="poem">Was it not she and that good man of worship,</p>
<p class="poem">Antony Woodville, her brother there,</p>
<p class="poem">That made him send Lord Hastings to the Tower,</p>
<p class="poem">From whence this present day he is deliver’d?</p>
<p class="poem">We are not safe, Clarence; we are not safe.</p>
<p class="poem1">CLARENCE: By heaven, I think there is no man is secure</p>
<p class="poem">But the queen’s kindred, and night-walking heralds</p>
<p class="poem">That trudge betwixt the king and Mistress Shore.</p>
<p class="poem">Heard you not what an humble suppliant</p>
</a><p class="poem"><a id="page_8"></a><a id="page_9">Lord Hastings was to her for his delivery?</a></p><a id="page_9">
<p class="poem1">GLOSTER: Humbly complaining to her deity</p>
<p class="poem">Got my Lord Chamberlain his liberty.</p>
<p class="poem">I’ll tell you what,—I think it is our way,</p>
<p class="poem">If we will keep in favour with the king,</p>
<p class="poem">To be her men and wear her livery:</p>
<p class="poem">The jealous o’er-worn widow, and herself,</p>
<p class="poem">Since that our brother dubb’d them gentlewomen,</p>
<p class="poem">Are mighty gossips in our monarchy.</p>
<p class="poem1">BRAKENBURY: I beseech your graces both to pardon me;</p>
<p class="poem">His majesty hath straitly given in charge</p>
<p class="poem">That no man shall have private conference,</p>
<p class="poem">Of what degree soever, with your brother.</p>
<p class="poem1">GLOSTER: Even so; an’t please your worship, Brakenbury,</p>
<p class="poem">You may partake of any thing we say:</p>
<p class="poem">We speak no treason, man;—we say the king</p>
<p class="poem">Is wise and virtuous; and his noble queen</p>
<p class="poem">Well struck in years, fair, and not jealous;—</p>
<p class="poem">We say that Shore’s wife hath a pretty foot,</p>
<p class="poem">A cherry lip, a bonny eye, a passing pleasing tongue;</p>
<p class="poem">And that the queen’s kindred are made gentlefolks:</p>
<p class="poem">How say you, sir? can you deny all this?</p>
<p class="poem1">BRAKENBURY: With this, my lord, myself have naught to do.</p>
<p class="poem1">GLOSTER: Naught to do with Mistress Shore! I tell thee, fellow,</p>
<p class="poem">He that doth naught with her, excepting one,</p>
<p class="poem">Were best to do it secretly alone.</p>
</a><p class="poem1"><a id="page_9"></a><a id="page_10">BRAKENBURY: What one, my lord?</a></p><a id="page_10">
<p class="poem1">GLOSTER: Her husband, knave:—wouldst thou betray me?</p>
<p class="poem1">BRAKENBURY: I do beseech your grace to pardon me; and, withal,</p>
<p class="poem">Forbear your conference with the noble duke.</p>
<p class="poem1">CLARENCE: We know thy charge, Brakenbury, and will obey.</p>
<p class="poem1">GLOSTER: We are the queen’s abjects and must obey.—</p>
<p class="poem">Brother, farewell: I will unto the king;</p>
<p class="poem">And whatsoe’er you will employ me in,—</p>
<p class="poem">Were it to call King Edward’s widow sister,—</p>
<p class="poem">I will perform it to enfranchise you.</p>
<p class="poem">Meantime, this deep disgrace in brotherhood</p>
<p class="poem">Touches me deeper than you can imagine.</p>
<p class="poem1">CLARENCE: I know it pleaseth neither of us well.</p>
<p class="poem1">GLOSTER: Well, your imprisonment shall not be long;</p>
<p class="poem">I will deliver or else lie for you:</p>
<p class="poem">Meantime, have patience.</p>
<p class="poem1">CLARENCE: I must perforce: farewell.</p>
<p class="poem2"><em class="italic">[Exeunt CLARENCE, BRAKENBURY, and guard.]</em></p>
<p class="poem">GLOSTER: Go tread the path that thou shalt ne’er return.</p>
<p class="poem">Simple, plain Clarence!—I do love thee so</p>
<p class="poem">That I will shortly send thy soul to heaven,</p>
<p class="poem">If heaven will take the present at our hands.—</p>
</a><p class="poem"><a id="page_10"></a><a id="page_11">But who comes here? The new-delivered Hastings?</a></p><a id="page_11">
<p class="poem2"><em class="italic">[Enter HASTINGS.]</em></p>
<p class="poem">HASTINGS: Good time of day unto my gracious lord!</p>
<p class="poem1">GLOSTER: As much unto my good Lord Chamberlain!</p>
<p class="poem">Well are you welcome to the open air.</p>
<p class="poem">How hath your lordship brook’d imprisonment?</p>
<p class="poem1">HASTINGS: With patience, noble lord, as prisoners must;</p>
<p class="poem">But I shall live, my lord, to give them thanks</p>
<p class="poem">That were the cause of my imprisonment.</p>
<p class="poem1">GLOSTER: No doubt, no doubt; and so shall Clarence too;</p>
<p class="poem">For they that were your enemies are his,</p>
<p class="poem">And have prevail’d as much on him as you.</p>
<p class="poem1">HASTINGS: More pity that the eagles should be mew’d</p>
<p class="poem">Whiles kites and buzzards prey at liberty.</p>
<p class="poem1">GLOSTER: What news abroad?</p>
<p class="poem1">HASTINGS: No news so bad abroad as this at home,—</p>
<p class="poem">The king is sickly, weak, and melancholy,</p>
<p class="poem">And his physicians fear him mightily.</p>
<p class="poem1">GLOSTER: Now, by Saint Paul, that news is bad indeed.</p>
<p class="poem">O, he hath kept an evil diet long,</p>
<p class="poem">And overmuch consum’d his royal person:</p>
<p class="poem"> ‘Tis very grievous to be thought upon.</p>
<p class="poem">What, is he in his bed?</p>
</a><p class="poem1"><a id="page_11"></a><a id="page_12">HASTINGS: He is.</a></p><a id="page_12">
<p class="poem1">GLOSTER: Go you before, and I will follow you.</p>
<p class="poem2"><em class="italic">[Exit HASTINGS.]</em></p>
<p class="poem">He cannot live, I hope; and must not die</p>
<p class="poem">Till George be pack’d with posthorse up to heaven.</p>
<p class="poem">I’ll in, to urge his hatred more to Clarence</p>
<p class="poem">With lies well steel’d with weighty arguments;</p>
<p class="poem">And, if I fail not in my deep intent,</p>
<p class="poem">Clarence hath not another day to live;</p>
<p class="poem">Which done, God take King Edward to his mercy,</p>
<p class="poem">And leave the world for me to bustle in!</p>
<p class="poem">For then I’ll marry Warwick’s youngest daughter:</p>
<p class="poem">What though I kill’d her husband and her father?</p>
<p class="poem">The readiest way to make the wench amends</p>
<p class="poem">Is to become her husband and her father:</p>
<p class="poem">The which will I; not all so much for love</p>
<p class="poem">As for another secret close intent,</p>
<p class="poem">By marrying her, which I must reach unto.</p>
<p class="poem">But yet I run before my horse to market:</p>
<p class="poem">Clarence still breathes; Edward still lives and reigns:</p>
<p class="poem">When they are gone, then must I count my gains.</p>
<p class="poem2"><em class="italic">[Exit.]</em></p>
</a><h3 class="ch-title" id="lev2"><a id="page_12"></a><a id="page_13"><span class="bold">Scene II. London. Another street</span></a></h3><a id="page_13">
<p class="poem2"><em class="italic">[Enter the corpse of King Henry the Sixth, borne in an open coffin, Gentlemen bearing halberds to guard it; and Lady Anne as mourner.]</em></p>
<p class="poem">ANNE: Set down, set down your honourable load,—</p>
<p class="poem">If honour may be shrouded in a hearse,—</p>
<p class="poem">Whilst I awhile obsequiously lament</p>
<p class="poem">Th’ untimely fall of virtuous Lancaster.—</p>
<p class="poem">Poor key-cold figure of a holy king!</p>
<p class="poem">Pale ashes of the house of Lancaster!</p>
<p class="poem">Thou bloodless remnant of that royal blood!</p>
<p class="poem">Be it lawful that I invocate thy ghost,</p>
<p class="poem">To hear the lamentations of poor Anne,</p>
<p class="poem">Wife to thy Edward, to thy slaughter’d son,</p>
<p class="poem">Stabb’d by the self-same hand that made these wounds!</p>
<p class="poem">Lo, in these windows that let forth thy life,</p>
<p class="poem">I pour the helpless balm of my poor eyes:—</p>
<p class="poem">O, cursèd be the hand that made these holes!</p>
<p class="poem">Cursèd the heart that had the heart to do it!</p>
<p class="poem">Cursèd the blood that let this blood from hence!</p>
</a><p class="poem"><a id="page_13"></a><a id="page_14">More direful hap betide that hated wretch</a></p><a id="page_14">
<p class="poem">That makes us wretched by the death of thee,</p>
<p class="poem">Than I can wish to adders, spiders, toads,</p>
<p class="poem">Or any creeping venom’d thing that lives!</p>
<p class="poem">If ever he have child, abortive be it,</p>
<p class="poem">Prodigious, and untimely brought to light,</p>
<p class="poem">Whose ugly and unnatural aspect</p>
<p class="poem">May fright the hopeful mother at the view;</p>
<p class="poem">And that be heir to his unhappiness!</p>
<p class="poem">If ever he have wife, let her be made</p>
<p class="poem">More miserable by the death of him</p>
<p class="poem">Than I am made by my young lord and thee!—</p>
<p class="poem">Come, now towards Chertsey with your holy load,</p>
<p class="poem">Taken from Paul’s to be interrèd there;</p>
<p class="poem">And still, as you are weary of this weight,</p>
<p class="poem">Rest you, whiles I lament King Henry’s corse.</p>
<p class="poem2"><em class="italic">[The Bearers take up the Corpse and advance.]</em></p>
<p class="poem2"><em class="italic">[Enter GLOSTER.]</em></p>
<p class="poem">GLOSTER: Stay, you that bear the corse, and set it down.</p>
<p class="poem1">ANNE: What black magician conjures up this fiend,</p>
<p class="poem">To stop devoted charitable deeds?</p>
<p class="poem1">GLOSTER: Villains, set down the corse; or, by Saint Paul,</p>
<p class="poem">I’ll make a corse of him that disobeys!</p>
<p class="poem1">FIRST GENTLEMAN: My lord, stand back, and let the coffin pass.</p>
<p class="poem1">GLOSTER: Unmanner’d dog! stand thou, when I command:</p>
<p class="poem">Advance thy halberd higher than my breast,</p>
<p class="poem">Or, by Saint Paul, I’ll strike thee to my foot</p>
<p class="poem">And spurn upon thee, beggar, for thy boldness.</p>
<p class="poem2"><em class="italic">[The Bearers set down the coffin.]</em></p>
<p class="poem">ANNE: What, do you tremble? are you all afraid?</p>
<p class="poem">Alas, I blame you not; for you are mortal,</p>
<p class="poem">And mortal eyes cannot endure the devil.—</p>
</a><p class="poem"><a id="page_14"></a><a id="page_15">Avaunt, thou dreadful minister of hell!</a></p><a id="page_15">
<p class="poem">Thou hadst but power over his mortal body,</p>
<p class="poem">His soul thou canst not have; therefore, be gone.</p>
<p class="poem1">GLOSTER: Sweet saint, for charity, be not so curst.</p>
<p class="poem1">ANNE: Foul devil, for God’s sake, hence and trouble us not;</p>
<p class="poem">For thou hast made the happy earth thy hell,</p>
<p class="poem">Fill’d it with cursing cries and deep exclaims.</p>
<p class="poem">If thou delight to view thy heinous deeds,</p>
<p class="poem">Behold this pattern of thy butcheries.—</p>
<p class="poem">O, gentlemen, see, see! dead Henry’s wounds</p>
<p class="poem">Open their congeal’d mouths and bleed afresh!</p>
<p class="poem">Blush, blush, thou lump of foul deformity;</p>
<p class="poem">For ‘tis thy presence that exhales this blood</p>
<p class="poem">From cold and empty veins, where no blood dwells;</p>
<p class="poem">Thy deeds, inhuman and unnatural,</p>
<p class="poem">Provokes this deluge most unnatural.—</p>
<p class="poem">O God, which this blood mad’st, revenge his death!</p>
<p class="poem">O earth, which this blood drink’st, revenge his death!</p>
<p class="poem">Either, heaven, with lightning strike the murderer dead;</p>
<p class="poem">Or, earth, gape open wide and eat him quick,</p>
<p class="poem">As thou dost swallow up this good king’s blood,</p>
<p class="poem">Which his hell-govern’d arm hath butchered!</p>
<p class="poem1">GLOSTER: Lady, you know no rules of charity,</p>
<p class="poem">Which renders good for bad, blessings for curses.</p>
<p class="poem1">ANNE: Villain, thou knowest nor law of God nor man:</p>
<p class="poem">No beast so fierce but knows some touch of pity.</p>
<p class="poem1">GLOSTER: But I know none, and therefore am no beast.</p>
</a><p class="poem1"><a id="page_15"></a><a id="page_16">ANNE: O wonderful, when devils tell the truth!</a></p><a id="page_16">
<p class="poem1">GLOSTER: More wonderful when angels are so angry.—</p>
<p class="poem">Vouchsafe, divine perfection of a woman,</p>
<p class="poem">Of these supposèd crimes to give me leave,</p>
<p class="poem">By circumstance, but to acquit myself.</p>
<p class="poem1">ANNE: Vouchsafe, diffus’d infection of a man,</p>
<p class="poem">Of these known evils but to give me leave,</p>
<p class="poem">By circumstance, to accuse thy cursèd self.</p>
<p class="poem1">GLOSTER: Fairer than tongue can name thee, let me have</p>
<p class="poem">Some patient leisure to excuse myself.</p>
<p class="poem1">ANNE: Fouler than heart can think thee, thou canst make</p>
<p class="poem">No excuse current but to hang thyself.</p>
<p class="poem1">GLOSTER: By such despair I should accuse myself.</p>
<p class="poem1">ANNE: And by despairing shalt thou stand excus’d;</p>
<p class="poem">For doing worthy vengeance on thyself,</p>
<p class="poem">That didst unworthy slaughter upon others.</p>
<p class="poem1">GLOSTER: Say that I slew them not?</p>
<p class="poem1">ANNE: Then say they were not slain:</p>
<p class="poem">But dead they are, and, devilish slave, by thee.</p>
<p class="poem1">GLOSTER: I did not kill your husband.</p>
<p class="poem1">ANNE: Why, then he is alive.</p>
</a><p class="poem1"><a id="page_16"></a><a id="page_17">GLOSTER: Nay, he is dead; and slain by Edward’s hand.</a></p><a id="page_17">
<p class="poem1">ANNE: In thy foul throat thou liest: Queen Margaret saw</p>
<p class="poem">Thy murderous falchion smoking in his blood;</p>
<p class="poem">The which thou once didst bend against her breast,</p>
<p class="poem">But that thy brothers beat aside the point.</p>
<p class="poem1">GLOSTER: I was provokèd by her slanderous tongue</p>
<p class="poem">That laid their guilt upon my guiltless shoulders.</p>
<p class="poem1">ANNE: Thou wast provokèd by thy bloody mind,</p>
<p class="poem">That never dreamt on aught but butcheries:</p>
<p class="poem">Didst thou not kill this king?</p>
<p class="poem1">GLOSTER: I grant ye.</p>
<p class="poem1">ANNE: Dost grant me, hedgehog? then, God grant me too</p>
<p class="poem">Thou mayst be damnèd for that wicked deed!</p>
<p class="poem">O, he was gentle, mild, and virtuous.</p>
<p class="poem1">GLOSTER: The better for the king of Heaven, that hath him.</p>
<p class="poem1">ANNE: He is in heaven, where thou shalt never come.</p>
<p class="poem1">GLOSTER: Let him thank me that holp to send him thither,</p>
<p class="poem">For he was fitter for that place than earth.</p>
<p class="poem1">ANNE: And thou unfit for any place but hell.</p>
<p class="poem1">GLOSTER: Yes, one place else, if you will hear me name it.</p>
</a><p class="poem1"><a id="page_17"></a><a id="page_18">ANNE: Some dungeon.</a></p><a id="page_18">
<p class="poem1">GLOSTER: Your bed-chamber.</p>
<p class="poem1">ANNE: Ill rest betide the chamber where thou liest!</p>
<p class="poem1">GLOSTER: So will it, madam, till I lie with you.</p>
<p class="poem1">ANNE: I hope so.</p>
<p class="poem1">GLOSTER: I know so.—But, gentle Lady Anne,—</p>
<p class="poem">To leave this keen encounter of our wits,</p>
<p class="poem">And fall something into a slower method,—</p>
<p class="poem">Is not the causer of the timeless deaths</p>
<p class="poem">Of these Plantagenets, Henry and Edward,</p>
<p class="poem">As blameful as the executioner?</p>
<p class="poem1">ANNE: Thou wast the cause and most accurs’d effect.</p>
<p class="poem1">GLOSTER: Your beauty was the cause of that effect;</p>
<p class="poem">Your beauty, that did haunt me in my sleep</p>
<p class="poem">To undertake the death of all the world,</p>
<p class="poem">So I might live one hour in your sweet bosom.</p>
<p class="poem1">ANNE: If I thought that, I tell thee, homicide,</p>
<p class="poem">These nails should rend that beauty from my cheeks.</p>
<p class="poem1">GLOSTER: These eyes could not endure that beauty’s wreck;</p>
<p class="poem">You should not blemish it if I stood by:</p>
<p class="poem">As all the world is cheerèd by the sun,</p>
<p class="poem">So I by that; it is my day, my life.</p>
</a><p class="poem1"><a id="page_18"></a><a id="page_19">ANNE: Black night o’ershade thy day, and death thy life!</a></p><a id="page_19">
<p class="poem1">GLOSTER: Curse not thyself, fair creature; thou art both.</p>
<p class="poem1">ANNE: I would I were, to be reveng’d on thee.</p>
<p class="poem1">GLOSTER: It is a quarrel most unnatural,</p>
<p class="poem">To be reveng’d on him that loveth thee.</p>
<p class="poem1">ANNE: It is a quarrel just and reasonable,</p>
<p class="poem">To be reveng’d on him that kill’d my husband.</p>
<p class="poem1">GLOSTER: He that bereft thee, lady, of thy husband,</p>
<p class="poem">Did it to help thee to a better husband.</p>
<p class="poem1">ANNE: His better doth not breathe upon the earth.</p>
<p class="poem1">GLOSTER: He lives that loves thee better than he could.</p>
<p class="poem1">ANNE: Name him.</p>
<p class="poem1">GLOSTER: Plantagenet.</p>
<p class="poem1">ANNE: Why, that was he.</p>
<p class="poem1">GLOSTER: The self-same name, but one of better nature.</p>
<p class="poem1">ANNE: Where is he?</p>
<p class="poem1">GLOSTER: Here.</p>
<p class="poem2"><em class="italic">[She spits at him.]</em></p>
</a><p class="poem"><a id="page_19"></a><a id="page_20">Why dost thou spit at me?</a></p><a id="page_20">
<p class="poem1">ANNE: Would it were mortal poison, for thy sake!</p>
<p class="poem1">GLOSTER: Never came poison from so sweet a place.</p>
<p class="poem1">ANNE: Never hung poison on a fouler toad.</p>
<p class="poem">Out of my sight! thou dost infect mine eyes.</p>
<p class="poem1">GLOSTER: Thine eyes, sweet lady, have infected mine.</p>
<p class="poem1">ANNE: Would they were basilisks to strike thee dead!</p>
<p class="poem1">GLOSTER: I would they were, that I might die at once;</p>
<p class="poem">For now they kill me with a living death.</p>
<p class="poem">Those eyes of thine from mine have drawn salt tears,</p>
<p class="poem">Sham’d their aspects with store of childish drops:</p>
<p class="poem">These eyes, which never shed remorseful tear,</p>
<p class="poem">No, when my father York and Edward wept,</p>
<p class="poem">To hear the piteous moan that Rutland made</p>
<p class="poem">When black-fac’d Clifford shook his sword at him;</p>
<p class="poem">Nor when thy warlike father, like a child,</p>
<p class="poem">Told the sad story of my father’s death,</p>
<p class="poem">And twenty times made pause, to sob and weep,</p>
<p class="poem">That all the standers-by had wet their cheeks,</p>
<p class="poem">Like trees bedash’d with rain; in that sad time</p>
<p class="poem">My manly eyes did scorn an humble tear;</p>
<p class="poem">And what these sorrows could not thence exhale,</p>
<p class="poem">Thy beauty hath, and made them blind with weeping.</p>
<p class="poem">I never su’d to friend nor enemy;</p>
<p class="poem">My tongue could never learn sweet smoothing word;</p>
<p class="poem">But, now thy beauty is propos’d my fee,</p>
</a><p class="poem"><a id="page_20"></a><a id="page_21">My proud heart sues, and prompts my tongue to speak.</a></p><a id="page_21">
<p class="poem2"><em class="italic">[She looks scornfully at him.]</em></p>
<p class="poem">Teach not thy lip such scorn; for it was made</p>
<p class="poem">For kissing, lady, not for such contempt.</p>
<p class="poem">If thy revengeful heart cannot forgive,</p>
<p class="poem">Lo, here I lend thee this sharp-pointed sword;</p>
<p class="poem">Which if thou please to hide in this true breast</p>
<p class="poem">And let the soul forth that adoreth thee,</p>
<p class="poem">I lay it naked to the deadly stroke,</p>
<p class="poem">And humbly beg the death upon my knee,</p>
<p class="poem">Nay, do not pause; for I did kill King Henry,—</p>
<p class="poem2"><em class="italic">[He lays his breast open; she offers at it with his sword.]</em></p>
<p class="poem">But ‘twas thy beauty that provokèd me.</p>
<p class="poem">Nay, now dispatch; ‘twas I that stabb’d young Edward,—</p>
<p class="poem2"><em class="italic">[She again offers at his breast.]</em></p>
<p class="poem">But ‘twas thy heavenly face that set me on.</p>
<p class="poem2"><em class="italic">[She lets fall the sword.]</em></p>
<p class="poem">Take up the sword again, or take up me.</p>
<p class="poem1">ANNE: Arise, dissembler: though I wish thy death,</p>
<p class="poem">I will not be thy executioner.</p>
<p class="poem1">GLOSTER: Then bid me kill myself, and I will do it.</p>
</a><p class="poem1"><a id="page_21"></a><a id="page_22">ANNE: I have already.</a></p><a id="page_22">
<p class="poem1">GLOSTER: That was in thy rage:</p>
<p class="poem">Speak it again, and even with the word,</p>
<p class="poem">This hand, which for thy love did kill thy love;</p>
<p class="poem">Shall, for thy love, kill a far truer love;</p>
<p class="poem">To both their deaths shalt thou be accessary.</p>
<p class="poem1">ANNE: I would I knew thy heart.</p>
<p class="poem1">GLOSTER: ‘Tis figured in my tongue.</p>
<p class="poem1">ANNE: I fear me both are false.</p>
<p class="poem1">GLOSTER: Then never was man true.</p>
<p class="poem1">ANNE: Well, well, put up your sword.</p>
<p class="poem1">GLOSTER: Say, then, my peace is made.</p>
<p class="poem1">ANNE: That shalt thou know hereafter.</p>
<p class="poem1">GLOSTER: But shall I live in hope?</p>
<p class="poem1">ANNE: All men, I hope, live so.</p>
<p class="poem1">GLOSTER: Vouchsafe to wear this ring.</p>
<p class="poem1">ANNE: To take is not to give.</p>
<p class="poem2"><em class="italic">[She puts on the ring.]</em></p>
</a><p class="poem1"><a id="page_22"></a><a id="page_23">GLOSTER: Look, how this ring encompasseth thy finger,</a></p><a id="page_23">
<p class="poem">Even so thy breast encloseth my poor heart;</p>
<p class="poem">Wear both of them, for both of them are thine.</p>
<p class="poem">And if thy poor devoted servant may</p>
<p class="poem">But beg one favour at thy gracious hand,</p>
<p class="poem">Thou dost confirm his happiness for ever.</p>
<p class="poem1">ANNE: What is it?</p>
<p class="poem1">GLOSTER: That it may please you leave these sad designs</p>
<p class="poem">To him that hath most cause to be a mourner,</p>
<p class="poem">And presently repair to Crosby Place;</p>
<p class="poem">Where,—after I have solemnly interr’d</p>
<p class="poem">At Chertsey monastery, this noble king,</p>
<p class="poem">And wet his grave with my repentant tears,—</p>
<p class="poem">I will with all expedient duty see you:</p>
<p class="poem">For divers unknown reasons, I beseech you,</p>
<p class="poem">Grant me this boon.</p>
<p class="poem1">ANNE: With all my heart; and much it joys me too</p>
<p class="poem">To see you are become so penitent.—</p>
<p class="poem">Tressel and Berkeley, go along with me.</p>
<p class="poem1">GLOSTER: Bid me farewell.</p>
<p class="poem1">ANNE: ‘Tis more than you deserve;</p>
<p class="poem">But since you teach me how to flatter you,</p>
<p class="poem">Imagine I have said farewell already.</p>
<p class="poem2"><em class="italic">[Exeunt Lady Anne, Tress, and Berk.]</em></p>
<p class="poem1">GLOSTER: Sirs, take up the corse.</p>
</a><p class="poem1"><a id="page_23"></a><a id="page_24">GENTLEMEN: Towards Chertsey, noble lord?</a></p><a id="page_24">
<p class="poem1">GLOSTER: No, to White Friars; there attend my coming.</p>
<p class="poem2"><em class="italic">[Exeunt the rest, with the Corpse.]</em></p>
<p class="poem">Was ever woman in this humour woo’d?</p>
<p class="poem">Was ever woman in this humour won?</p>
<p class="poem">I’ll have her; but I will not keep her long.</p>
<p class="poem">What! I that kill’d her husband and his father,</p>
<p class="poem">To take her in her heart’s extremest hate;</p>
<p class="poem">With curses in her mouth, tears in her eyes,</p>
<p class="poem">The bleeding witness of her hatred by;</p>
<p class="poem">Having God, her conscience, and these bars against me,</p>
<p class="poem">And I no friends to back my suit withal,</p>
<p class="poem">But the plain devil and dissembling looks,</p>
<p class="poem">And yet to win her,—all the world to nothing!</p>
<p class="poem">Ha!</p>
<p class="poem">Hath she forgot already that brave prince,</p>
<p class="poem">Edward, her lord, whom I, some three months since,</p>
<p class="poem">Stabb’d in my angry mood at Tewksbury?</p>
<p class="poem">A sweeter and a lovelier gentleman,—</p>
<p class="poem">Fram’d in the prodigality of nature,</p>
<p class="poem">Young, valiant, wise, and, no doubt, right royal,—</p>
<p class="poem">The spacious world cannot again afford:</p>
<p class="poem">And will she yet abase her eyes on me,</p>
<p class="poem">That cropp’d the golden prime of this sweet prince,</p>
<p class="poem">And made her widow to a woeful bed?</p>
<p class="poem">On me, whose all not equals Edward’s moiety?</p>
<p class="poem">On me, that halt and am misshapen thus?</p>
<p class="poem">My dukedom to a beggarly denier,</p>
</a><p class="poem"><a id="page_24"></a><a id="page_25">I do mistake my person all this while:</a></p><a id="page_25">
<p class="poem">Upon my life, she finds, although I cannot,</p>
<p class="poem">Myself to be a marvellous proper man.</p>
<p class="poem">I’ll be at charges for a looking-glass;</p>
<p class="poem">And entertain a score or two of tailors,</p>
<p class="poem">To study fashions to adorn my body:</p>
<p class="poem">Since I am crept in favour with myself,</p>
<p class="poem">I will maintain it with some little cost.</p>
<p class="poem">But first I’ll turn yon fellow in his grave;</p>
<p class="poem">And then return lamenting to my love.—</p>
<p class="poem">Shine out, fair sun, till I have bought a glass,</p>
<p class="poem">That I may see my shadow as I pass.</p>
<p class="poem2"><em class="italic">[Exit.]</em></p>
</a><h3 class="ch-title" id="lev3"><a id="page_25"></a><a id="page_26"><span class="bold">Scene III. London. A Room in the Palace</span></a></h3><a id="page_26">
<p class="poem2"><em class="italic">[Enter QUEEN ELIZABETH, LORD RIVERS, and LORD GREY.]</em></p>
<p class="poem1">RIVERS: Have patience, madam: there’s no doubt his majesty</p>
<p class="poem">Will soon recover his accustom’d health.</p>
<p class="poem1">GREY: In that you brook it ill, it makes him worse:</p>
<p class="poem">Therefore, for God’s sake, entertain good comfort,</p>
<p class="poem">And cheer his grace with quick and merry eyes.</p>
<p class="poem1">QUEEN ELIZABETH: If he were dead, what would betide on me?</p>
<p class="poem1">GREY: No other harm but loss of such a lord.</p>
<p class="poem1">QUEEN ELIZABETH: The loss of such a lord includes all harms.</p>
<p class="poem1">GREY: The heavens have bless’d you with a goodly son</p>
<p class="poem">To be your comforter when he is gone.</p>
<p class="poem1">QUEEN ELIZABETH: Ah, he is young; and his minority</p>
<p class="poem">Is put unto the trust of Richard Gloster,</p>
<p class="poem">A man that loves not me, nor none of you.</p>
<p class="poem1">RIVERS: Is it concluded he shall be protector?</p>
<p class="poem1">QUEEN ELIZABETH: It is determin’d, not concluded yet:</p>
<p class="poem">But so it must be, if the king miscarry.</p>
<p class="poem2"><em class="italic">[Enter BUCKINGHAM and STANLEY.]</em></p>
</a><p class="poem1"><a id="page_26"></a><a id="page_27">GREY: Here come the Lords of Buckingham and Stanley.</a></p><a id="page_27">
<p class="poem1">BUCKINGHAM: Good time of day unto your royal grace!</p>
<p class="poem1">STANLEY: God make your majesty joyful as you have been!</p>
<p class="poem1">QUEEN ELIZABETH: The Countess Richmond, good my Lord of Stanley,</p>
<p class="poem">To your good prayer will scarcely say amen.</p>
<p class="poem">Yet, Stanley, notwithstanding she’s your wife,</p>
<p class="poem">And loves not me, be you, good lord, assur’d</p>
<p class="poem">I hate not you for her proud arrogance.</p>
<p class="poem1">STANLEY: I do beseech you, either not believe</p>
<p class="poem">The envious slanders of her false accusers;</p>
<p class="poem">Or, if she be accus’d on true report,</p>
<p class="poem">Bear with her weakness, which I think proceeds</p>
<p class="poem">From wayward sickness, and no grounded malice.</p>
<p class="poem1">QUEEN ELIZABETH: Saw you the king to-day, my Lord of Stanley?</p>
<p class="poem1">STANLEY: But now the Duke of Buckingham and I</p>
<p class="poem">Are come from visiting his majesty.</p>
<p class="poem1">QUEEN ELIZABETH: What likelihood of his amendment, lords?</p>
<p class="poem1">BUCKINGHAM: Madam, good hope; his grace speaks cheerfully.</p>
<p class="poem1">QUEEN ELIZABETH: God grant him health! Did you confer with him?</p>
</a><p class="poem1"><a id="page_27"></a><a id="page_28">BUCKINGHAM: Ay, madam; he desires to make atonement</a></p><a id="page_28">
<p class="poem">Between the Duke of Gloster and your brothers,</p>
<p class="poem">And between them and my lord chamberlain;</p>
<p class="poem">And sent to warn them to his royal presence.</p>
<p class="poem1">QUEEN ELIZABETH: Would all were well!—but that will never be:</p>
<p class="poem">I fear our happiness is at the height.</p>
<p class="poem2"><em class="italic">[Enter GLOSTER, HASTINGS, and DORSET.]</em></p>
<p class="poem1">GLOSTER: They do me wrong, and I will not endure it:—</p>
<p class="poem">Who are they that complain unto the king</p>
<p class="poem">That I, forsooth, am stern and love them not?</p>
<p class="poem">By holy Paul, they love his grace but lightly</p>
<p class="poem">That fill his ears with such dissentious rumours.</p>
<p class="poem">Because I cannot flatter and look fair,</p>
<p class="poem">Smile in men’s faces, smooth, deceive, and cog,</p>
<p class="poem">Duck with French nods and apish courtesy,</p>
<p class="poem">I must be held a rancorous enemy.</p>
<p class="poem">Cannot a plain man live, and think no harm,</p>
<p class="poem">But thus his simple truth must be abus’d</p>
<p class="poem">With silken, sly, insinuating Jacks?</p>
<p class="poem1">GREY: To who in all this presence speaks your grace?</p>
<p class="poem1">GLOSTER: To thee, that hast nor honesty nor grace.</p>
<p class="poem">When have I injur’d thee? when done thee wrong?—</p>
<p class="poem">Or thee?—or thee?—or any of your faction?</p>
<p class="poem">A plague upon you all! His royal grace,—</p>
<p class="poem">Whom God preserve better than you would wish!—</p>
</a><p class="poem"><a id="page_28"></a><a id="page_29">Cannot be quiet scarce a breathing while,</a></p><a id="page_29">
<p class="poem">But you must trouble him with lewd complaints.</p>
<p class="poem1">QUEEN ELIZABETH: Brother of Gloster, you mistake the matter.</p>
<p class="poem">The king, on his own royal disposition,</p>
<p class="poem">And not provok’d by any suitor else—</p>
<p class="poem">Aiming, belike, at your interior hatred</p>
<p class="poem">That in your outward action shows itself</p>
<p class="poem">Against my children, brothers, and myself—</p>
<p class="poem">Makes him to send; that thereby he may gather</p>
<p class="poem">The ground of your ill-will, and so remove it.</p>
<p class="poem1">GLOSTER: I cannot tell: the world is grown so bad</p>
<p class="poem">That wrens make prey where eagles dare not perch:</p>
<p class="poem">Since every Jack became a gentleman,</p>
<p class="poem">There’s many a gentle person made a Jack.</p>
<p class="poem1">QUEEN ELIZABETH: Come, come, we know your meaning, brother Gloster;</p>
<p class="poem">You envy my advancement, and my friends’;</p>
<p class="poem">God grant we never may have need of you!</p>
<p class="poem1">GLOSTER: Meantime, God grants that we have need of you:</p>
<p class="poem">Our brother is imprison’d by your means,</p>
<p class="poem">Myself disgrac’d, and the nobility</p>
<p class="poem">Held in contempt; while great promotions</p>
<p class="poem">Are daily given to ennoble those</p>
<p class="poem">That scarce, some two days since, were worth a noble.</p>
<p class="poem1">QUEEN ELIZABETH: By Him that rais’d me to this careful height</p>
</a><p class="poem"><a id="page_29"></a><a id="page_30">From that contented hap which I enjoy’d,</a></p><a id="page_30">
<p class="poem">I never did incense his majesty</p>
<p class="poem">Against the Duke of Clarence, but have been</p>
<p class="poem">An earnest advocate to plead for him.</p>
<p class="poem">My lord, you do me shameful injury</p>
<p class="poem">Falsely to draw me in these vile suspects.</p>
<p class="poem1">GLOSTER: You may deny that you were not the mean</p>
<p class="poem">Of my Lord Hastings’ late imprisonment.</p>
<p class="poem1">RIVERS: She may, my lord; for,—</p>
<p class="poem1">GLOSTER: She may, Lord Rivers?—why, who knows not so?</p>
<p class="poem">She may do more, sir, than denying that:</p>
<p class="poem">She may help you to many fair preferments;</p>
<p class="poem">And then deny her aiding hand therein,</p>
<p class="poem">And lay those honours on your high desert.</p>
<p class="poem">What may she not? She may,—ay, marry, may she,—</p>
<p class="poem1">RIVERS: What, marry, may she?</p>
<p class="poem1">GLOSTER.: What, marry, may she! marry with a king,</p>
<p class="poem">A bachelor, and a handsome stripling too:</p>
<p class="poem">I wis your grandam had a worser match.</p>
<p class="poem1">QUEEN ELIZABETH: My Lord of Gloster, I have too long borne</p>
<p class="poem">Your blunt upbraidings and your bitter scoffs:</p>
<p class="poem">By heaven, I will acquaint his majesty</p>
<p class="poem">Of those gross taunts that oft I have endur’d.</p>
<p class="poem">I had rather be a country servant-maid</p>
<p class="poem">Than a great queen with this condition,—</p>
<p class="poem">To be so baited, scorn’d, and stormed at.</p>
</a><p class="poem2"><a id="page_30"></a><a id="page_31"><em class="italic">[Enter old QUEEN MARGARET, behind.]</em></a></p><a id="page_31">
<p class="poem">Small joy have I in being England’s queen.</p>
<p class="poem1">QUEEN MARGARET: And lessen’d be that small, God, I beseech Him!</p>
<p class="poem">Thy honour, state, and seat, is due to me.</p>
<p class="poem1">GLOSTER: What! Threat you me with telling of the king?</p>
<p class="poem">Tell him, and spare not: look what I have said</p>
<p class="poem">I will avouch in presence of the king:</p>
<p class="poem">I dare adventure to be sent to the Tower.</p>
<p class="poem">‘Tis time to speak,—my pains are quite forgot.</p>
<p class="poem1">QUEEN MARGARET: Out, devil! I do remember them too well:</p>
<p class="poem">Thou kill’dst my husband Henry in the Tower,</p>
<p class="poem">And Edward, my poor son, at Tewksbury.</p>
<p class="poem1">GLOSTER: Ere you were queen, ay, or your husband king,</p>
<p class="poem">I was a pack-horse in his great affairs;</p>
<p class="poem">A weeder-out of his proud adversaries,</p>
<p class="poem">A liberal rewarder of his friends;</p>
<p class="poem">To royalize his blood I spilt mine own.</p>
<p class="poem1">QUEEN MARGARET: Ay, and much better blood than his or thine.</p>
<p class="poem1">GLOSTER: In all which time you and your husband Grey</p>
<p class="poem">Were factious for the house of Lancaster;—</p>
<p class="poem">And, Rivers, so were you: was not your husband</p>
<p class="poem">In Margaret’s battle at Saint Albans slain?</p>
<p class="poem">Let me put in your minds, if you forget,</p>
</a><p class="poem"><a id="page_31"></a><a id="page_32">What you have been ere this, and what you are;</a></p><a id="page_32">
<p class="poem">Withal, what I have been, and what I am.</p>
<p class="poem1">QUEEN MARGARET: A murderous villain, and so still thou art.</p>
<p class="poem1">GLOSTER: Poor Clarence did forsake his father, Warwick;</p>
<p class="poem">Ay, and forswore himself,—which Jesu pardon!—</p>
<p class="poem1">QUEEN MARGARET: Which God revenge!</p>
<p class="poem1">GLOSTER: To fight on Edward’s party for the crown;</p>
<p class="poem">And for his meed, poor lord, he is mew’d up.</p>
<p class="poem">I would to God my heart were flint, like Edward’s,</p>
<p class="poem">Or Edward’s soft and pitiful, like mine:</p>
<p class="poem">I am too childish-foolish for this world.</p>
<p class="poem1">QUEEN MARGARET: Hie thee to hell for shame and leave this world,</p>
<p class="poem">Thou cacodemon! there thy kingdom is.</p>
<p class="poem1">RIVERS: My Lord of Gloster, in those busy days</p>
<p class="poem">Which here you urge to prove us enemies,</p>
<p class="poem">We follow’d then our lord, our sovereign king:</p>
<p class="poem">So should we you, if you should be our king.</p>
<p class="poem1">GLOSTER: If I should be!—I had rather be a pedler:</p>
<p class="poem">Far be it from my heart, the thought thereof!</p>
<p class="poem1">QUEEN ELIZABETH: As little joy, my lord, as you suppose</p>
<p class="poem">You should enjoy, were you this country’s king,—</p>
<p class="poem">As little joy you may suppose in me,</p>
<p class="poem">That I enjoy, being the queen thereof.</p>
</a><p class="poem1"><a id="page_32"></a><a id="page_33">QUEEN MARGARET: As little joy enjoys the queen thereof;</a></p><a id="page_33">
<p class="poem">For I am she, and altogether joyless.</p>
<p class="poem">I can no longer hold me patient.—</p>
<p class="poem2"><em class="italic">[Advancing.]</em></p>
<p class="poem">Hear me, you wrangling pirates, that fall out</p>
<p class="poem">In sharing that which you have pill’d from me!</p>
<p class="poem">Which of you trembles not that looks on me?</p>
<p class="poem">If not that, I am queen, you bow like subjects,</p>
<p class="poem">Yet that, by you depos’d, you quake like rebels?</p>
<p class="poem">Ah, gentle villain, do not turn away!</p>
<p class="poem1">GLOSTER: Foul wrinkled witch, what mak’st thou in my sight?</p>
<p class="poem1">QUEEN MARGARET: But repetition of what thou hast marr’d,</p>
<p class="poem">That will I make before I let thee go.</p>
<p class="poem1">GLOSTER: Wert thou not banishèd on pain of death?</p>
<p class="poem1">QUEEN MARGARET: I was; but I do find more pain in banishment</p>
<p class="poem">Than death can yield me here by my abode.</p>
<p class="poem">A husband and a son thou ow’st to me,—</p>
<p class="poem">And thou a kingdom,—all of you allegiance:</p>
<p class="poem">This sorrow that I have, by right is yours;</p>
<p class="poem">And all the pleasures you usurp are mine.</p>
<p class="poem1">GLOSTER: The curse my noble father laid on thee,</p>
<p class="poem">When thou didst crown his warlike brows with paper,</p>
<p class="poem">And with thy scorns drew’st rivers from his eyes;</p>
</a><p class="poem"><a id="page_33"></a><a id="page_34">And then to dry them gav’st the Duke a clout</a></p><a id="page_34">
<p class="poem">Steep’d in the faultless blood of pretty Rutland;—</p>
<p class="poem">His curses, then from bitterness of soul</p>
<p class="poem">Denounc’d against thee, are all fallen upon thee;</p>
<p class="poem">And God, not we, hath plagu’d thy bloody deed.</p>
<p class="poem1">QUEEN ELIZABETH: So just is God, to right the innocent.</p>
<p class="poem1">HASTINGS: O, ‘twas the foulest deed to slay that babe,</p>
<p class="poem">And the most merciless that e’er was heard of.</p>
<p class="poem1">RIVERS: Tyrants themselves wept when it was reported.</p>
<p class="poem1">DORSET: No man but prophesied revenge for it.</p>
<p class="poem1">BUCKINGHAM: Northumberland, then present, wept to see it.</p>
<p class="poem1">QUEEN MARGARET: What, were you snarling all before I came,</p>
<p class="poem">Ready to catch each other by the throat,</p>
<p class="poem">And turn you all your hatred now on me?</p>
<p class="poem">Did York’s dread curse prevail so much with heaven</p>
<p class="poem">That Henry’s death, my lovely Edward’s death,</p>
<p class="poem">Their kingdom’s loss, my woeful banishment,</p>
<p class="poem">Should all but answer for that peevish brat?</p>
<p class="poem">Can curses pierce the clouds and enter heaven?—</p>
<p class="poem">Why, then, give way, dull clouds, to my quick curses!—</p>
<p class="poem">Though not by war, by surfeit die your king,</p>
<p class="poem">As ours by murder, to make him a king!</p>
<p class="poem">Edward thy son, that now is Prince of Wales,</p>
<p class="poem">For Edward our son, that was Prince of Wales,</p>
<p class="poem">Die in his youth by like untimely violence!</p>
</a><p class="poem"><a id="page_34"></a><a id="page_35">Thyself a queen, for me that was a queen,</a></p><a id="page_35">
<p class="poem">Outlive thy glory, like my wretched self!</p>
<p class="poem">Long mayest thou live to wail thy children’s death;</p>
<p class="poem">And see another, as I see thee now,</p>
<p class="poem">Deck’d in thy rights, as thou art stall’d in mine!</p>
<p class="poem">Long die thy happy days before thy death;</p>
<p class="poem">And, after many lengthen’d hours of grief,</p>
<p class="poem">Die neither mother, wife, nor England’s queen!—</p>
<p class="poem">Rivers and Dorset, you were standers by,—</p>
<p class="poem">And so wast thou, Lord Hastings,—when my son</p>
<p class="poem">Was stabb’d with bloody daggers: God, I pray Him,</p>
<p class="poem">That none of you may live his natural age,</p>
<p class="poem">But by some unlook’d accident cut off!</p>
<p class="poem1">GLOSTER: Have done thy charm, thou hateful wither’d hag.</p>
<p class="poem1">QUEEN MARGARET: And leave out thee? stay, dog, for thou shalt hear me.</p>
<p class="poem">If heaven have any grievous plague in store</p>
<p class="poem">Exceeding those that I can wish upon thee,</p>
<p class="poem">O, let them keep it till thy sins be ripe,</p>
<p class="poem">And then hurl down their indignation</p>
<p class="poem">On thee, the troubler of the poor world’s peace!</p>
<p class="poem">The worm of conscience still be-gnaw thy soul!</p>
<p class="poem">Thy friends suspect for traitors while thou liv’st,</p>
<p class="poem">And take deep traitors for thy dearest friends!</p>
<p class="poem">No sleep close up that deadly eye of thine,</p>
<p class="poem">Unless it be while some tormenting dream</p>
<p class="poem">Affrights thee with a hell of ugly devils!</p>
<p class="poem">Thou elvish-mark’d, abortive, rooting hog!</p>
<p class="poem">Thou that wast seal’d in thy nativity</p>
<p class="poem">The slave of nature and the son of hell!</p>
</a><p class="poem"><a id="page_35"></a><a id="page_36">Thou slander of thy heavy mother’s womb!</a></p><a id="page_36">
<p class="poem">Thou loathèd issue of thy father’s loins!</p>
<p class="poem">Thou rag of honour! thou detested—</p>
<p class="poem1">GLOSTER: Margaret.</p>
<p class="poem1">QUEEN MARGARET: Richard!</p>
<p class="poem1">GLOSTER: Ha!</p>
<p class="poem1">QUEEN MARGARET: I call thee not.</p>
<p class="poem1">GLOSTER: I cry thee mercy then; for I did think</p>
<p class="poem">That thou hadst call’d me all these bitter names.</p>
<p class="poem1">QUEEN MARGARET: Why, so I did; but look’d for no reply.</p>
<p class="poem">O, let me make the period to my curse!</p>
<p class="poem1">GLOSTER: ‘Tis done by me, and ends in—Margaret.</p>
<p class="poem1">QUEEN ELIZABETH: Thus have you breath’d your curse against yourself.</p>
<p class="poem1">QUEEN MARGARET: Poor painted queen, vain flourish of my fortune!</p>
<p class="poem">Why strew’st thou sugar on that bottled spider,</p>
<p class="poem">Whose deadly web ensnareth thee about?</p>
<p class="poem">Fool, fool! thou whett’st a knife to kill thyself.</p>
<p class="poem">The day will come that thou shalt wish for me</p>
<p class="poem">To help thee curse this poisonous bunch-back’d toad.</p>
<p class="poem1">HASTINGS: False-boding woman, end thy frantic curse,</p>
</a><p class="poem"><a id="page_36"></a><a id="page_37">Lest to thy harm thou move our patience.</a></p><a id="page_37">
<p class="poem1">QUEEN MARGARET: Foul shame upon you! you have all mov’d mine.</p>
<p class="poem1">RIVERS: Were you well serv’d, you would be taught your duty.</p>
<p class="poem1">QUEEN MARGARET: To serve me well, you all should do me duty,</p>
<p class="poem">Teach me to be your queen, and you my subjects:</p>
<p class="poem">O, serve me well, and teach yourselves that duty!</p>
<p class="poem1">DORSET: Dispute not with her,—she is lunatic.</p>
<p class="poem1">QUEEN MARGARET: Peace, master marquis, you are malapert:</p>
<p class="poem">Your fire-new stamp of honour is scarce current:</p>
<p class="poem">O, that your young nobility could judge</p>
<p class="poem">What ‘twere to lose it, and be miserable!</p>
<p class="poem">They that stand high have many blasts to shake them;</p>
<p class="poem">And if they fall they dash themselves to pieces.</p>
<p class="poem1">GLOSTER: Good counsel, marry:—learn it, learn it, marquis.</p>
<p class="poem1">DORSET: It touches you, my lord, as much as me.</p>
<p class="poem1">GLOSTER: Ay, and much more: but I was born so high,</p>
<p class="poem">Our aery buildeth in the cedar’s top,</p>
<p class="poem">And dallies with the wind, and scorns the sun.</p>
<p class="poem1">QUEEN MARGARET: And turns the sun to shade;—alas! alas!—</p>
<p class="poem">Witness my son, now in the shade of death;</p>
</a><p class="poem"><a id="page_37"></a><a id="page_38">Whose bright out-shining beams thy cloudy wrath,</a></p><a id="page_38">
<p class="poem">Hath in eternal darkness folded up.</p>
<p class="poem">Your aery buildeth in our aery’s nest:—</p>
<p class="poem">O God that seest it, do not suffer it;</p>
<p class="poem">As it is won with blood, lost be it so!</p>
<p class="poem1">BUCKINGHAM: Peace, peace, for shame, if not for charity.</p>
<p class="poem1">QUEEN MARGARET: Urge neither charity nor shame to me:</p>
<p class="poem">Uncharitably with me have you dealt,</p>
<p class="poem">And shamefully my hopes by you are butcher’d.</p>
<p class="poem">My charity is outrage, life my shame,—</p>
<p class="poem">And in that shame still live my sorrow’s rage!</p>
<p class="poem1">BUCKINGHAM: Have done, have done.</p>
<p class="poem1">QUEEN MARGARET: O princely Buckingham, I’ll kiss thy hand,</p>
<p class="poem">In sign of league and amity with thee:</p>
<p class="poem">Now fair befall thee and thy noble house!</p>
<p class="poem">Thy garments are not spotted with our blood,</p>
<p class="poem">Nor thou within the compass of my curse.</p>
<p class="poem1">BUCKINGHAM: Nor no one here; for curses never pass</p>
<p class="poem">The lips of those that breathe them in the air.</p>
<p class="poem1">QUEEN MARGARET: I will not think but they ascend the sky,</p>
<p class="poem">And there awake God’s gentle-sleeping peace.</p>
<p class="poem">O Buckingham, take heed of yonder dog!</p>
<p class="poem">Look, when he fawns he bites; and when he bites,</p>
<p class="poem">His venom tooth will rankle to the death:</p>
<p class="poem">Have not to do with him, beware of him;</p>
</a><p class="poem"><a id="page_38"></a><a id="page_39">Sin, death, and hell have set their marks on him,</a></p><a id="page_39">
<p class="poem">And all their ministers attend on him.</p>
<p class="poem1">GLOSTER: What doth she say, my Lord of Buckingham?</p>
<p class="poem1">BUCKINGHAM: Nothing that I respect, my gracious lord.</p>
<p class="poem1">QUEEN MARGARET: What, dost thou scorn me for my gentle counsel?</p>
<p class="poem">And soothe the devil that I warn thee from?</p>
<p class="poem">O, but remember this another day,</p>
<p class="poem">When he shall split thy very heart with sorrow,</p>
<p class="poem">And say, poor Margaret was a prophetess!—</p>
<p class="poem">Live each of you the subjects to his hate,</p>
<p class="poem">And he to yours, and all of you to God’s!</p>
<p class="poem2"><em class="italic">[Exit.]</em></p>
<p class="poem">BUCKINGHAM: My hair doth stand an end to hear her curses.</p>
<p class="poem1">RIVERS: And so doth mine: I muse why she’s at liberty.</p>
<p class="poem1">GLOSTER: I cannot blame her: by God’s holy mother,</p>
<p class="poem">She hath had too much wrong; and I repent</p>
<p class="poem">My part thereof that I have done to her.</p>
<p class="poem1">QUEEN ELIZABETH: I never did her any, to my knowledge.</p>
<p class="poem1">GLOSTER: Yet you have all the vantage of her wrong.</p>
<p class="poem">I was too hot to do somebody good,</p>
<p class="poem">That is too cold in thinking of it now.</p>
<p class="poem">Marry, as for Clarence, he is well repaid;</p>
</a><p class="poem"><a id="page_39"></a><a id="page_40">He is frank’d up to fatting for his pains;</a></p><a id="page_40">
<p class="poem">God pardon them that are the cause thereof!</p>
<p class="poem1">RIVERS: A virtuous and a Christian-like conclusion,</p>
<p class="poem">To pray for them that have done scathe to us!</p>
<p class="poem1">GLOSTER: So do I ever being well advis’d;</p>
<p class="poem2"><em class="italic">[Aside]</em></p>
<p class="poem">For had I curs’d now, I had curs’d myself.</p>
<p class="poem2"><em class="italic">[Enter CATESBY.]</em></p>
<p class="poem">CATESBY: Madam, his majesty doth can for you,—</p>
<p class="poem">And for your grace,—and you, my noble lords.</p>
<p class="poem1">QUEEN ELIZABETH: Catesby, I come.—Lords, will you go with me?</p>
<p class="poem1">RIVERS: We wait upon your grace.</p>
<p class="poem2"><em class="italic">[Exeunt all but GLOSTER.]</em></p>
<p class="poem1">GLOSTER: I do the wrong, and first begin to brawl.</p>
<p class="poem">The secret mischiefs that I set abroach</p>
<p class="poem">I lay unto the grievous charge of others.</p>
<p class="poem">Clarence,—whom I indeed have cast in darkness,—</p>
<p class="poem">I do beweep to many simple gulls;</p>
<p class="poem">Namely, to Stanley, Hastings, Buckingham;</p>
<p class="poem">And tell them ‘Tis the queen and her allies</p>
<p class="poem">That stir the king against the duke my brother.</p>
</a><p class="poem"><a id="page_40"></a><a id="page_41">Now they believe it; and withal whet me</a></p><a id="page_41">
<p class="poem">To be reveng’d on Rivers, Vaughn, Grey:</p>
<p class="poem">But then I sigh; and, with a piece of Scripture,</p>
<p class="poem">Tell them that God bids us do good for evil:</p>
<p class="poem">And thus I clothe my naked villany</p>
<p class="poem">With odd old ends stol’n forth of holy writ;</p>
<p class="poem">And seem a saint when most I play the devil.—</p>
<p class="poem">But, soft, here come my executioners.</p>
<p class="poem2"><em class="italic">[Enter two MURDERERS.]</em></p>
<p class="poem">How now, my hardy stout resolvèd mates!</p>
<p class="poem">Are you now going to dispatch this thing?</p>
<p class="poem1">FIRST MURDERER: We are, my lord, and come to have the warrant,</p>
<p class="poem">That we may be admitted where he is.</p>
<p class="poem1">GLOSTER: Well thought upon;—I have it here about me:</p>
<p class="poem2"><em class="italic">[Gives the warrant.]</em></p>
<p class="poem">When you have done, repair to Crosby Place.</p>
<p class="poem">But, sirs, be sudden in the execution,</p>
<p class="poem">Withal obdúrate, do not hear him plead;</p>
<p class="poem">For Clarence is well-spoken, and perhaps</p>
<p class="poem">May move your hearts to pity, if you mark him.</p>
<p class="poem1">FIRST MURDERER: Tut, tut, my lord, we will not stand to prate;</p>
<p class="poem">Talkers are no good doers: be assur’d</p>
<p class="poem">We go to use our hands, and not our tongues.</p>
</a><p class="poem1"><a id="page_41"></a><a id="page_42">GLOSTER; Your eyes drop millstones when fools’ eyes fall tears:</a></p><a id="page_42">
<p class="poem">I like you, lads;—about your business straight;</p>
<p class="poem">Go, go, despatch.</p>
<p class="poem1">FIRST MURDERER: We will, my noble lord.</p>
<p class="poem2"><em class="italic">[Exeunt.]</em></p>
</a><h3 class="ch-title" id="lev4"><a id="page_42"></a><a id="page_43"><span class="bold">Scene IV. London. A Room in the Tower</span></a></h3><a id="page_43">
<p class="poem2"><em class="italic">[Enter CLARENCE and BRAKENBURY.]</em></p>
<p class="poem">BRAKENBURY: Why looks your grace so heavily to-day?</p>
<p class="poem1">CLARENCE: O, I have pass’d a miserable night,</p>
<p class="poem">So full of fearful dreams, of ugly sights,</p>
<p class="poem">That, as I am a Christian faithful man,</p>
<p class="poem">I would not spend another such a night</p>
<p class="poem">Though ‘twere to buy a world of happy days,—</p>
<p class="poem">So full of dismal terror was the time!</p>
<p class="poem1">BRAKENBURY: What was your dream, my lord? I pray you tell me.</p>
<p class="poem1">CLARENCE: Methoughts that I had broken from the Tower,</p>
<p class="poem">And was embark’d to cross to Burgundy;</p>
<p class="poem">And, in my company, my brother Gloster;</p>
<p class="poem">Who from my cabin tempted me to walk</p>
<p class="poem">Upon the hatches: thence we look’d toward England,</p>
<p class="poem">And cited up a thousand heavy times,</p>
<p class="poem">During the wars of York and Lancaster,</p>
<p class="poem">That had befall’n us. As we pac’d along</p>
<p class="poem">Upon the giddy footing of the hatches,</p>
<p class="poem">Methought that Gloster stumbled; and, in falling,</p>
<p class="poem">Struck me, that thought to stay him, overboard</p>
<p class="poem">Into the tumbling billows of the main.</p>
<p class="poem">O Lord, methought what pain it was to drown!</p>
<p class="poem">What dreadful noise of waters in my ears!</p>
<p class="poem">What sights of ugly death within my eyes!</p>
<p class="poem">Methoughts I saw a thousand fearful wrecks;</p>
</a><p class="poem"><a id="page_43"></a><a id="page_44">A thousand men that fishes gnaw’d upon;</a></p><a id="page_44">
<p class="poem">Wedges of gold, great anchors, heaps of pearl,</p>
<p class="poem">Inestimable stones, unvalued jewels,</p>
<p class="poem">All scatt’red in the bottom of the sea:</p>
<p class="poem">Some lay in dead men’s skulls; and in the holes</p>
<p class="poem">Where eyes did once inhabit there were crept,—</p>
<p class="poem">As ‘twere in scorn of eyes,—reflecting gems,</p>
<p class="poem">That woo’d the slimy bottom of the deep,</p>
<p class="poem">And mock’d the dead bones that lay scatter’d by.</p>
<p class="poem1">BRAKENBURY: Had you such leisure in the time of death</p>
<p class="poem">To gaze upon these secrets of the deep?</p>
<p class="poem1">CLARENCE: Methought I had; and often did I strive</p>
<p class="poem">To yield the ghost: but still the envious flood</p>
<p class="poem">Stopp’d in my soul, and would not let it forth</p>
<p class="poem">To find the empty, vast, and wandering air;</p>
<p class="poem">But smother’d it within my panting bulk,</p>
<p class="poem">Who almost burst to belch it in the sea.</p>
<p class="poem1">BRAKENBURY: Awak’d you not in this sore agony?</p>
<p class="poem1">CLARENCE: No, no, my dream was lengthen’d after life;</p>
<p class="poem">O, then began the tempest to my soul!</p>
<p class="poem">I pass’d, methought, the melancholy flood</p>
<p class="poem">With that grim ferryman which poets write of,</p>
<p class="poem">Unto the kingdom of perpetual night.</p>
<p class="poem">The first that there did greet my stranger soul</p>
<p class="poem">Was my great father-in-law, renownèd Warwick;</p>
<p class="poem">Who spake aloud, “What scourge for perjury</p>
<p class="poem">Can this dark monarchy afford false Clarence?”</p>
<p class="poem">And so he vanish’d: then came wandering by</p>
</a><p class="poem"><a id="page_44"></a><a id="page_45">A shadow like an Angel, with bright hair</a></p><a id="page_45">
<p class="poem">Dabbled in blood; and he shriek’d out aloud</p>
<p class="poem">“Clarence is come,—false, fleeting, perjur’d Clarence,—</p>
<p class="poem">That stabb’d me in the field by Tewksbury;—</p>
<p class="poem">Seize on him, Furies, take him to your torments!”</p>
<p class="poem">With that, methoughts, a legion of foul fiends</p>
<p class="poem">Environ’d me, and howlèd in mine ears</p>
<p class="poem">Such hideous cries that, with the very noise,</p>
<p class="poem">I trembling wak’d, and for a season after</p>
<p class="poem">Could not believe but that I was in hell,—</p>
<p class="poem">Such terrible impression made my dream.</p>
<p class="poem1">BRAKENBURY: No marvel, lord, though it affrighted you;</p>
<p class="poem">I am afraid, methinks, to hear you tell it.</p>
<p class="poem1">CLARENCE: Ah, Brakenbury, I have done these things</p>
<p class="poem">That now give evidence against my soul,</p>
<p class="poem">For Edward’s sake; and see how he requites me!—</p>
<p class="poem">O God! If my deep prayers cannot appease Thee,</p>
<p class="poem">But Thou wilt be aveng’d on my misdeeds,</p>
<p class="poem">Yet execute Thy wrath in me alone,—</p>
<p class="poem">O, spare my guiltless wife and my poor children!—</p>
<p class="poem">Keeper, I prithee sit by me awhile;</p>
<p class="poem">My soul is heavy, and I fain would sleep.</p>
<p class="poem1">BRAKENBURY: I will, my lord; God give your grace good rest!—</p>
<p class="poem2"><em class="italic">[CLARENCE reposes himself on a chair.]</em></p>
<p class="poem">Sorrow breaks seasons and reposing hours,</p>
<p class="poem">Makes the night morning and the noontide night.</p>
</a><p class="poem"><a id="page_45"></a><a id="page_46">Princes have but their titles for their glories,</a></p><a id="page_46">
<p class="poem">An outward honour for an inward toil;</p>
<p class="poem">And, for unfelt imaginations,</p>
<p class="poem">They often feel a world of restless cares:</p>
<p class="poem">So that, between their tides and low name,</p>
<p class="poem">There’s nothing differs but the outward fame.</p>
<p class="poem2"><em class="italic">[Enter the two MURDERERS.]</em></p>
<p class="poem">FIRST MURDERER: Ho! who’s here?</p>
<p class="poem1">BRAKENBURY: What wouldst thou, fellow, and how cam’st thou hither?</p>
<p class="poem1">FIRST MURDERER: I would speak with Clarence, and I came hither on my legs.</p>
<p class="poem1">BRAKENBURY: What, so brief?</p>
<p class="poem1">SECOND MURDERER: ‘Tis better, sir, than to be tedious.—Let him see our commission and talk no more.</p>
<p class="poem2"><em class="italic">[A paper is delivered to BRAKENBURY, who reads it.]</em></p>
<p class="poem">BRAKENBURY: I am, in this, commanded to deliver</p>
<p class="poem">The noble Duke of Clarence to your hands:—</p>
<p class="poem">I will not reason what is meant hereby,</p>
<p class="poem">Because I will be guiltless of the meaning.</p>
<p class="poem">There lies the Duke asleep,—and there the keys;</p>
<p class="poem">I’ll to the king and signify to him</p>
<p class="poem">That thus I have resign’d to you my charge.</p>
</a><p class="poem1"><a id="page_46"></a><a id="page_47">FIRST MURDERER: You may, sir; ‘Tis a point of wisdom: fare you well.</a></p><a id="page_47">
<p class="poem2"><em class="italic">[Exit BRAKENBURY.]</em></p>
<p class="poem">SECOND MURDERER: What, shall we stab him as he sleeps?</p>
<p class="poem1">FIRST MURDERER: No; he’ll say ‘twas done cowardly, when he wakes.</p>
<p class="poem1">SECOND MURDERER: When he wakes! why, fool, he shall never wake until the great judgment-day.</p>
<p class="poem1">FIRST MURDERER: Why, then he’ll say we stabb’d him sleeping.</p>
<p class="poem1">SECOND MURDERER: The urging of that word “judgment” hath bred a kind of remorse in me.</p>
<p class="poem1">FIRST MURDERER: What, art thou afraid?</p>
<p class="poem1">SECOND MURDERER: Not to kill him, having a warrant for it; but to be damned for killing him, from the which no warrant can defend me.</p>
<p class="poem1">FIRST MURDERER: I thought thou hadst been resolute.</p>
<p class="poem1">SECOND MURDERER: So I am, to let him live.</p>
<p class="poem1">FIRST MURDERER: I’ll back to the Duke of Gloster and tell him so.</p>
</a><p class="poem1"><a id="page_47"></a><a id="page_48">SECOND MURDERER: Nay, I pr’ythee, stay a little: I hope my holy humour will change; it was wont to hold me but while one tells twenty.</a></p><a id="page_48">
<p class="poem1">FIRST MURDERER: How dost thou feel thyself now?</p>
<p class="poem1">SECOND MURDERER: Faith, some certain dregs of conscience are yet within me.</p>
<p class="poem1">FIRST MURDERER: Remember our reward, when the deed’s done.</p>
<p class="poem1">SECOND MURDERER: Zounds, he dies: I had forgot the reward.</p>
<p class="poem1">FIRST MURDERER: Where’s thy conscience now?</p>
<p class="poem1">SECOND MURDERER: O, in the Duke of Gloster’s purse.</p>
<p class="poem1">FIRST MURDERER: So, when he opens his purse to give us our reward, thy conscience flies out.</p>
<p class="poem1">SECOND MURDERER: ‘Tis no matter; let it go; there’s few or none will entertain it.</p>
<p class="poem1">FIRST MURDERER: What if it come to thee again?</p>
</a><p class="poem1"><a id="page_48">SECOND MURDERER: I’ll not meddle with it,—it makes a man coward; a man cannot steal, but it accuseth him; a man cannot swear, but it checks him; a man cannot lie with his neighbour’s wife, but it detects him: ‘Tis a blushing shame-faced spirit that mutinies in a man’s bosom; it fills a man full of obstacles: it made </a><a id="page_49">me once restore a purse of gold that by chance I found; it beggars any man that keeps it: it is turned out of towns and cities for a dangerous thing; and every man that means to live well endeavours to trust to himself and live without it.</a></p><a id="page_49">
<p class="poem1">FIRST MURDERER: Zounds, ‘Tis even now at my elbow, persuading me not to kill the duke.</p>
<p class="poem1">SECOND MURDERER: Take the devil in thy mind, and believe him not; he would insinuate with thee but to make thee sigh.</p>
<p class="poem1">FIRST MURDERER: I am strong-framed; he cannot prevail with me.</p>
<p class="poem1">SECOND MURDERER: Spoke like a tall man that respects thy reputation. Come, shall we fall to work?</p>
<p class="poem1">FIRST MURDERER: Take him on the costard with the hilts of thy sword, and then throw him in the malmsey-butt in the next room.</p>
<p class="poem1">SECOND MURDERER; O excellent device! and make a sop of him.</p>
<p class="poem1">FIRST MURDERER: Soft! he wakes.</p>
<p class="poem1">SECOND MURDERER: Strike!</p>
<p class="poem1">FIRST MURDERER: No, we’ll reason with him.</p>
<p class="poem1">CLARENCE: Where art thou, keeper? give me a cup of wine.</p>
</a><p class="poem1"><a id="page_49"></a><a id="page_50">SECOND MURDERER: You shall have wine enough, my lord, anon.</a></p><a id="page_50">
<p class="poem1">CLARENCE: In God’s name, what art thou?</p>
<p class="poem1">FIRST MURDERER: A man, as you are.</p>
<p class="poem1">CLARENCE: But not as I am, royal.</p>
<p class="poem1">SECOND MURDERER: Nor you as we are, loyal.</p>
<p class="poem1">CLARENCE: Thy voice is thunder, but thy looks are humble.</p>
<p class="poem1">FIRST MURDERER: My voice is now the king’s, my looks mine own.</p>
<p class="poem1">CLARENCE: How darkly and how deadly dost thou speak!</p>
<p class="poem">Your eyes do menace me; why look you pale?</p>
<p class="poem">Who sent you hither? Wherefore do you come?</p>
<p class="poem1">SECOND MURDERER; To, to, to—</p>
<p class="poem1">CLARENCE: To murder me?</p>
<p class="poem1">BOTH MURDERERS: Ay, ay.</p>
<p class="poem1">CLARENCE: You scarcely have the hearts to tell me so,</p>
<p class="poem">And therefore cannot have the hearts to do it.</p>
<p class="poem">Wherein, my friends, have I offended you?</p>
<p class="poem1">FIRST MURDERER: Offended us you have not, but the king.</p>
</a><p class="poem1"><a id="page_50"></a><a id="page_51">CLARENCE: I shall be reconcil’d to him again.</a></p><a id="page_51">
<p class="poem1">SECOND MURDERER: Never, my lord; therefore prepare to die.</p>
<p class="poem1">CLARENCE: Are you drawn forth among a world of men</p>
<p class="poem">To slay the innocent? What is my offence?</p>
<p class="poem">Where is the evidence that doth accuse me?</p>
<p class="poem">What lawful quest have given their verdict up</p>
<p class="poem">Unto the frowning judge? or who pronounc’d</p>
<p class="poem">The bitter sentence of poor Clarence’ death?</p>
<p class="poem">Before I be convíct by course of law,</p>
<p class="poem">To threaten me with death is most unlawful.</p>
<p class="poem">I charge you, as you hope to have redemption</p>
<p class="poem">By Christ’s dear blood shed for our grievous sins,</p>
<p class="poem">That you depart, and lay no hands on me:</p>
<p class="poem">The deed you undertake is damnable.</p>
<p class="poem1">FIRST MURDERER: What we will do, we do upon command.</p>
<p class="poem1">SECOND MURDERER: And he that hath commanded is our king.</p>
<p class="poem1">CLARENCE: Erroneous vassals! the great King of kings</p>
<p class="poem">Hath in the table of his law commanded</p>
<p class="poem">That thou shalt do no murder: will you then</p>
<p class="poem">Spurn at His edict and fulfil a man’s?</p>
<p class="poem">Take heed; for He holds vengeance in His hand</p>
<p class="poem">To hurl upon their heads that break His law.</p>
<p class="poem1">SECOND MURDERER: And that same vengeance doth He hurl on thee</p>
<p class="poem">For false forswearing, and for murder too:</p>
</a><p class="poem"><a id="page_51"></a><a id="page_52">Thou didst receive the sacrament to fight</a></p><a id="page_52">
<p class="poem">In quarrel of the house of Lancaster.</p>
<p class="poem1">FIRST MURDERER: And like a traitor to the name of God</p>
<p class="poem">Didst break that vow; and with thy treacherous blade</p>
<p class="poem">Unripp’dst the bowels of thy sovereign’s son.</p>
<p class="poem1">SECOND MURDERER: Whom thou wast sworn to cherish and defend.</p>
<p class="poem1">FIRST MURDERER: How canst thou urge God’s dreadful law to us,</p>
<p class="poem">When thou hast broke it in such dear degree?</p>
<p class="poem1">CLARENCE: Alas! for whose sake did I that ill deed?</p>
<p class="poem">For Edward, for my brother, for his sake:</p>
<p class="poem">He sends you not to murder me for this;</p>
<p class="poem">For in that sin he is as deep as I.</p>
<p class="poem">If God will be avengèd for the deed,</p>
<p class="poem">O, know you yet He doth it publicly.</p>
<p class="poem">Take not the quarrel from His powerful arm;</p>
<p class="poem">He needs no indirect or lawless course</p>
<p class="poem">To cut off those that have offended Him.</p>
<p class="poem1">FIRST MURDERER: Who made thee, then, a bloody minister</p>
<p class="poem">When gallant-springing brave Plantagenet,</p>
<p class="poem">That princely novice, was struck dead by thee?</p>
<p class="poem1">CLARENCE: My brother’s love, the devil, and my rage.</p>
<p class="poem1">FIRST MURDERER: Thy brother’s love, our duty, and thy faults,</p>
<p class="poem">Provoke us hither now to slaughter thee.</p>
</a><p class="poem1"><a id="page_52"></a><a id="page_53">CLARENCE: If you do love my brother, hate not me;</a></p><a id="page_53">
<p class="poem">I am his brother, and I love him well.</p>
<p class="poem">If you are hir’d for meed, go back again,</p>
<p class="poem">And I will send you to my brother Gloster,</p>
<p class="poem">Who shall reward you better for my life</p>
<p class="poem">Than Edward will for tidings of my death.</p>
<p class="poem1">SECOND MURDERER: You are deceiv’d, your brother Gloster hates you.</p>
<p class="poem1">CLARENCE; O, no, he loves me, and he holds me dear:</p>
<p class="poem">Go you to him from me.</p>
<p class="poem1">FIRST MURDERER: Ay, so we will.</p>
<p class="poem1">CLARENCE: Tell him when that our princely father York</p>
<p class="poem">Bless’d his three sons with his victorious arm</p>
<p class="poem">And charg’d us from his soul to love each other,</p>
<p class="poem">He little thought of this divided friendship:</p>
<p class="poem">Bid Gloster think of this, and he will weep.</p>
<p class="poem1">FIRST MURDERER: Ay, millstones; as he lesson’d us to weep.</p>
<p class="poem1">CLARENCE: O, do not slander him, for he is kind.</p>
<p class="poem1">FIRST MURDERER: Right, as snow in harvest.—Come, you deceive yourself:</p>
<p class="poem"> ‘Tis he that sends us to destroy you here.</p>
<p class="poem1">CLARENCE: It cannot be; for he bewept my fortune,</p>
<p class="poem">And hugg’d me in his arms, and swore, with sobs,</p>
</a><p class="poem"><a id="page_53"></a><a id="page_54">That he would labour my delivery.</a></p><a id="page_54">
<p class="poem1">FIRST MURDERER: Why, so he doth, when he delivers you</p>
<p class="poem">From this earth’s thraldom to the joys of heaven.</p>
<p class="poem1">SECOND MURDERER: Make peace with God, for you must die, my lord.</p>
<p class="poem1">CLARENCE: Have you that holy feeling in your souls,</p>
<p class="poem">To counsel me to make my peace with God,</p>
<p class="poem">And are you yet to your own souls so blind</p>
<p class="poem">That you will war with God by murdering me?—</p>
<p class="poem">O, sirs, consider, they that set you on</p>
<p class="poem">To do this deed will hate you for the deed.</p>
<p class="poem1">SECOND MURDERER; What shall we do?</p>
<p class="poem1">CLARENCE: Relent, and save your souls.</p>
<p class="poem1">FIRST MURDERER: Relent! ‘Tis cowardly and womanish.</p>
<p class="poem1">CLARENCE: Not to relent is beastly, savage, devilish.</p>
<p class="poem">Which of you, if you were a prince’s son,</p>
<p class="poem">Being pent from liberty, as I am now,—</p>
<p class="poem">If two such murderers as yourselves came to you,—</p>
<p class="poem">Would not entreat for life?—</p>
<p class="poem">My friend, I spy some pity in thy looks;</p>
<p class="poem">O, if thine eye be not a flatterer,</p>
<p class="poem">Come thou on my side, and entreat for me,</p>
<p class="poem">As you would beg, were you in my distress:</p>
<p class="poem">A begging prince what beggar pities not?</p>
</a><p class="poem1"><a id="page_54"></a><a id="page_55">SECOND MURDERER: Look behind you, my lord.</a></p><a id="page_55">
<p class="poem1">FIRST MURDERER.</p>
<p class="poem2"><em class="italic">[Stabs him.]</em></p>
<p class="poem">Take that, and that: if all this will not do,</p>
<p class="poem">I’ll drown you in the malmsey-butt within.</p>
<p class="poem2"><em class="italic">[Exit with the body.]</em></p>
<p class="poem">SECOND MURDERER: A bloody deed, and desperately dispatch’d!</p>
<p class="poem">How fain, like Pilate, would I wash my hands</p>
<p class="poem">Of this most grievous murder!</p>
<p class="poem2"><em class="italic">[Re-enter FIRST MURDERER.]</em></p>
<p class="poem">FIRST MURDERER: How now, what mean’st thou that thou help’st me not?</p>
<p class="poem">By heavens, the duke shall know how slack you have been!</p>
<p class="poem1">SECOND MURDERER: I would he knew that I had sav’d his brother!</p>
<p class="poem">Take thou the fee, and tell him what I say;</p>
<p class="poem">For I repent me that the duke is slain.</p>
<p class="poem2"><em class="italic">[Exit.]</em></p>
<p class="poem">FIRST MURDERER: So do not I: go, coward as thou art.—</p>
<p class="poem">Well, I’ll go hide the body in some hole,</p>
<p class="poem">Till that the duke give order for his burial:</p>
</a><p class="poem"><a id="page_55"></a><a id="page_56">And when I have my meed, I will away;</a></p><a id="page_56">
<p class="poem">For this will out, and then I must not stay.</p>
<p class="poem2"><em class="italic">[Exit.]</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Chapter01.vue?25787a9b